<template>
    <div class="gt_header">
       <div class="wrapp">
            <div @click="down" class="hearer_down">
                <img src="https://cdn.hotplaydl.com/static/img/logo.png" class="gt_logo">
                <div class="down_info">
                    <div class="down_title">GamesToday</div>
                    <div class="down_size">{{size}}MB</div>
                </div>
                <div class="downbtn">
                    <van-button type="default" :icon="downimg" class="detailbtn" size="small "> Download </van-button>
                </div>
            </div>
            <div class="header_search">
                <van-search 
                :placeholder="placeHolder" 
                @search="onSearch" 
                v-model="value"
                show-action
                class="isearch" >
                    <div slot="action" @click="onSearch" class="search">Search</div>
                </van-search>
            </div>
       </div>
    </div>
</template>

<script>
import downMixin from '@/mixins/downMixin'
import searchMixin from '@/mixins/searchMixin'
export default {
    mixins: [downMixin, searchMixin],
}
</script>

<style lang="scss" scoped>
.gt_header {
    width: 100%;
    background-color: #fff;
    .wrapp {
        display: flex;
        justify-content: space-between;
        align-items: center;

        margin-top: 0!important;
        .hearer_down {
            padding: 12px 0;
            display: flex;
            justify-content: space-between;
            align-items: center;
            .gt_logo {
                width: 40px;
                height: 40px;
            }
            .down_info {
                display: flex;
                flex-direction: column;
                justify-content: space-around;
                align-items: flex-start;
                margin: 0 24px;
                
                font-family: Roboto, Roboto;
                font-weight: 400;
                font-size: 12px;
                color: #4A90E2;
            }
            .downbtn {
                .detailbtn {
                    padding: 8px 16px;
                    background-color: #4A90E2;
                    border-radius: 4px;
                    font-size: 12px;
                    color: white;
                    line-height: 28px;
                }
            }
        }
        .header_search {
            .search {
                padding: 8px 12px;
                background: #4A90E2;
                font-weight: 600;
                font-size: 12px;
                color: #FFFFFF;
                line-height: 12px;
                text-align: center;
                border-radius: 4px;
            }
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/components/PcHeader.vue